import React from 'react';

import * as styles from './UnsupportedSection.styles';

export const UnsupportedSection = () => <div css={styles.outer} data-testid="unsupportedSection" />;
